export enum WellKnownBillTypes {
  invoice = 1,
  creditNote = 2,
}
